import { render } from "./ButtonPage.vue?vue&type=template&id=18eae142"
import script from "./ButtonPage.vue?vue&type=script&lang=js"
export * from "./ButtonPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__